import React from 'react';

import { inject, observer } from 'mobx-react';

import {PATH_PORTALE} from '../config/portale-config';


@inject("rootStore")
@observer
class Fermo extends React.Component {

  constructor(props) {
    super(props);
    
 
  }

  componentDidMount() {
    //console.log("ho montato il componente")
   }

  
  
   
  render() {
    //console.log("sto nel render")
   
          return (<>
          <div className='container-fluid pt-5'>
          <div className="notification shadow alert alert-warning d-flex" role="alert">
          <div className="alert-content">
          <h3 className="notification-title">Servizio non disponibile temporaneamente</h3>
                 <p>{ this.props.rootStore.fermoStore.messaggio}</p>
              
                  <a  href= {process.env.CONTEXT_PORTALE + PATH_PORTALE + '/home'} className="btn btn-primary" type="button" title="Ripristina">
                    <i className="fas fa-sync"></i>  Torna all'area autenticata
                  </a>
          </div>
          </div>
          </div>
                </>
          )
          
    
   

  }
}



export default Fermo;
